import { useFormContext } from 'react-hook-form';

import { InlineBanner, InlineBannerType } from '@xemplo/inline-banner';

import { MilestoneFormValues } from '../edit-payrun-milestones.types';

import { SEQUENTIAL_ERROR } from './milestone-validation';

/**
 * Surfaces the sequential error raised by the resolver. The error is anchored
 * to the offending chain field's parent path, so the banner scans the chain
 * for it (see `milestoneResolver`).
 */
export function ValidationBanner() {
  const { formState } = useFormContext<MilestoneFormValues>();

  const allErrors = Object.values(formState.errors);

  const firstSequentialError = allErrors.find(
    (error) => error.type === SEQUENTIAL_ERROR.type,
  );

  if (!firstSequentialError?.message) return null;

  return (
    <InlineBanner
      type={InlineBannerType.Alert}
      title={firstSequentialError.message.toString()}
    />
  );
}
